import React, { forwardRef, memo, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentLanguage, t } from "../../store/slices/languageSlice";
import { Box, Divider, IconButton, Tab, Tabs, Typography } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import _ from "lodash";
import { Col, Row } from "react-bootstrap";
import Utils from "../../../utils/Utils";
import { Link } from "react-router-dom";
import CustomModal from "../CustomModal";
import Buttons from "../button/Buttons";
import YouTube from "react-youtube";
import { n } from "../../../utils/Labels";
import { selectFeatureById } from "../../pages/products/store/listSlice";
import Image from "../Images/Image";
import { setSliderOptions } from "../../store/slices/sliderSlice";
import CmkSvgIcon from "../../core/CmkSvgIcon";
import clsx from "clsx";

const TabScrollable = forwardRef((props, ref) => {
  const { item } = props;
  const { default_property_tab } = item || {};
  const properties = item?.properties || [];
  const dispatch = useDispatch();
  const lang = useSelector(selectCurrentLanguage);

  const [value, setValue] = React.useState(null);
  const [tabs, setTabs] = useState([]);

  useEffect(() => {
    setTabs(properties.filter((f) => !_.isEmpty(f.props_list)));
  }, [properties]);

  useEffect(() => {
    if (_.isEmpty(tabs)) return;

    setValue(default_property_tab || tabs?.[0]?.property_tag);
  }, [default_property_tab, tabs]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabList
          onChange={handleChange}
          aria-label="scrollable tabs properties"
          variant="scrollable"
          allowScrollButtonsMobile
          // indicatorColor={""}
        >
          {
            // !_.isEmpty(properties) &&
            //   properties
            //     .filter((f) => !_.isEmpty(f.props_list))
            tabs.map((p, _index) => {
              const { property_tag, name, props_list } = p;
              if (_.isEmpty(props_list)) return null;

              return (
                <Tab
                  sx={{
                    color: value == _index ? "#000" : "inherit",
                  }}
                  key={_index}
                  label={dispatch(t(`WEBSITE.${property_tag}`))}
                  value={`${property_tag}`}
                />
              );
            })
          }
        </TabList>
      </Box>

      {
        // !_.isEmpty(properties) &&
        //   properties
        //     .filter((f) => !_.isEmpty(f.props_list))
        tabs.map((p, _index) => {
          const { property_tag, name, props_list, table_name } = p;
          if (_.isEmpty(props_list)) return null;

          const td = table_name.replace("dt_", "");

          return (
            <TabPanel key={_index} value={`${property_tag}`}>
              <Row xs={2}>
                {props_list.map((p, _p) => {
                  const { props_list, name_lang } = p;

                  if (_.isEmpty(props_list)) {
                    const { name_lang, picture, file_download, ...rest } = p;
                    const n =
                      name_lang && name_lang[lang] ? name_lang[lang] : "";
                    let pic = "";
                    let file = "";

                    Object.keys(rest).map((k) => {
                      if (k.includes(`${td}_id`)) {
                        pic = picture
                          ? Utils.formatURL(
                              `data_table/${k.replace(`_id`, "")}/picture/${
                                rest[k]
                              }/${picture}?s=xs`
                            )
                          : null;
                        file = file_download
                          ? Utils.formatURL(
                              `data_table/${k.replace(
                                `_id`,
                                ""
                              )}/file_download/${
                                rest[k]
                              }/${file_download}?download=${n}`
                            )
                          : null;
                      }
                    });

                    return (
                      <Col
                        key={_p}
                        xl={2}
                        lg={3}
                        md={4}
                        xs={6}
                        className="tab-item"
                      >
                        {file ? (
                          <Link
                            aria-label="link"
                            target={"_blank"}
                            to={file}
                            className="no-underline hover:no-underline"
                          >
                            <div className="flex flex-col py-[20px] md:items-center">
                              <img
                                height={200}
                                width={200}
                                className="rounded-lg"
                                src={pic || Utils.placeholderImage()}
                                alt={n}
                                data-no-retina=""
                              />

                              <div className="w-full">
                                <span className="font-medium text-sm text-darkgray ">
                                  {n}
                                </span>
                              </div>
                            </div>
                          </Link>
                        ) : (
                          <div className="flex flex-col py-[20px] md:items-center">
                            <img
                              height={200}
                              width={200}
                              className="rounded-lg"
                              src={pic || Utils.placeholderImage()}
                              alt={n}
                              data-no-retina=""
                            />

                            <div className="w-full">
                              <span className="font-medium text-sm text-darkgray ">
                                {n}
                              </span>
                            </div>
                          </div>
                        )}
                      </Col>
                    );
                  }

                  const _n =
                    name_lang && name_lang[lang] ? name_lang[lang] : "";
                  const name_p =
                    name_lang && name_lang[lang] ? name_lang[lang] : "";
                  const { description_lang, external_url, external_url_lang } =
                    p;

                  return (
                    <Box key={_p} className={"w-full mb-10"}>
                      <Typography
                        color={"text.secondary"}
                        className="mt-2 !font-bold"
                      >
                        {_n}
                      </Typography>

                      <Divider
                        className="my-2"
                        sx={{
                          borderColor: "rgba(0, 0, 0, 0.6)",
                        }}
                      />

                      {n(external_url_lang) && (
                        <Link
                          aria-label="link"
                          target={"_blank"}
                          to={n(external_url_lang)}
                          className="no-underline hover:no-underline"
                        >
                          <Typography
                            color={"text.secondary"}
                            className="mt-3 !font-bold !text-sm "
                          >
                            {dispatch(t("WEBSITE.more_details"))}{" "}
                            <i className="feather-external-link"></i>
                          </Typography>
                        </Link>
                      )}
                      {/* {external_url && external_url[lang] && (
                        <Link
                          aria-label="link"
                          target={"_blank"}
                          to={external_url[lang]}
                          className="no-underline hover:no-underline"
                        >
                          <Typography
                            color={"text.secondary"}
                            className="mt-3 !font-bold !text-sm "
                          >
                            {dispatch(t("WEBSITE.more_details"))}{" "}
                            <i className="feather-external-link"></i>
                          </Typography>
                        </Link>
                      )} */}
                      <Row xs={2} className="mt-[30px]">
                        {!_.isEmpty(props_list) &&
                          props_list.map((p, _p) => (
                            <TabItem {...p} key={_p} td={td} name_p={name_p} />
                          ))}
                      </Row>
                    </Box>
                  );
                })}
              </Row>
            </TabPanel>
          );
        })
      }
    </TabContext>
  );
});

const TabItem = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const lang = useSelector(selectCurrentLanguage);

  const {
    name_lang,
    picture,
    secondary_picture,
    file_download,
    video,
    video_url,
    td,
    name_p,
    property_features_ids,
    description_lang,
    ...rest
  } = props;
  const name = name_lang && name_lang[lang] ? name_lang[lang] : "";
  let v = "";
  let yt = "";
  let pic = "";
  let pic_2 = "";
  let file = "";

  Object.keys(rest).map((k) => {
    if (k.includes(`${td}_id`)) {
      v = video
        ? Utils.formatURL(
            `data_table/${k.replace(`_id`, "")}/video/${rest[k]}/${video}`
          )
        : null;
      yt = video_url ? Utils.getYoutubeVideoId(video_url) : null;
      pic = picture
        ? Utils.formatURL(
            `data_table/${k.replace(`_id`, "")}/picture/${
              rest[k]
            }/${picture}?s=md`
          )
        : null;
      pic_2 = secondary_picture
        ? Utils.formatURL(
            `data_table/${k.replace(`_id`, "")}/secondary_picture/${
              rest[k]
            }/${secondary_picture}?s=md`
          )
        : null;
      file = file_download
        ? Utils.formatURL(
            `data_table/${k.replace(`_id`, "")}/file_download/${
              rest[k]
            }/${file_download}?download=${name_p}-${name}`
          )
        : null;
    }
  });

  const features = Utils.parseJSON(property_features_ids, "array");

  const handleClick = () =>
    dispatch(
      setSliderOptions({
        open: true,
        items: [
          {
            picture_src: pic,
          },
          ...(pic_2
            ? [
                {
                  picture_src: pic_2,
                },
              ]
            : []),
        ],
      })
    );

  if (!_.isEmpty(features)) {
    return (
      <Col xl={3} lg={4} md={6} xs={12} className="tab-item mb-[30px]">
        <div className="w-full h-full border rounded-lg overflow-hidden space-y-3 pb-3">
          <div className="w-full h-[250px] max-h-[250px] group overflow-hidden relative">
            <Image
              size="md"
              ImgProps={{
                src: pic,
                className: clsx(
                  "h-full object-contain absolute",
                  pic_2 && "transition-opacity duration-300"
                ),
              }}
              BoxProps={{
                className: clsx(
                  "!h-[250px] !min-h-[250px] flex items-center justify-center border-b overflow-hidden relative"
                ),
                onClick: handleClick,
              }}
            >
              {pic_2 && (
                <img
                  src={`${pic_2}?s=md`}
                  className={clsx(
                    "w-full h-full object-cover opacity-0 group-hover:!opacity-100 absolute transition-opacity duration-300 z-50"
                  )}
                  draggable="false"
                  onMouseDown={(e) => e.preventDefault()}
                />
              )}
            </Image>
          </div>

          <div className="w-full flex flex-col flex-1 px-3 space-y-2">
            <span className="font-medium text-sm text-gray-500">{name}</span>

            {n(description_lang) && (
              <span className="font-normal text-xs text-gray-500">
                {n(description_lang)}
              </span>
            )}

            <div className="w-full flex flex-col space-y-1">
              {features.map((f) => (
                <ItemFeature key={f} item={f} />
              ))}
            </div>
          </div>
        </div>
      </Col>
    );
  }

  return (
    <Col xl={2} lg={3} md={4} xs={6} className="tab-item">
      {file ? (
        <div
          // aria-label="link"
          // target={"_self"}
          // to={file}
          className="no-underline hover:no-underline hover:cursor-pointer"
          onClick={() => {
            Utils.downloadFile(file);
          }}
        >
          <div className="flex flex-col py-[20px] md:items-center relative">
            {(v || yt) && (
              <CustomModal.Wrapper
                className="absolute top-0 left-0 w-full h-full -mt-[10px] flex justify-center items-center"
                modalBtn={
                  <IconButton>
                    <i className="icon-control-play text-white text-[30px]" />
                  </IconButton>
                }
              >
                <div className="w-[1020px] max-w-full relative rounded mx-auto">
                  <div className="fit-video">
                    {v && (
                      <iframe
                        width="100%"
                        height="100%"
                        className="shadow-[0_0_8px_rgba(0,0,0,0.06)]"
                        controls
                        src={v}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    )}
                    {yt && (
                      <YouTube
                        videoId={yt}
                        opts={{
                          height: "100%",
                          width: "100%",
                          playerVars: {
                            autoplay: 1,
                          },
                        }}
                      />
                    )}
                  </div>
                </div>
              </CustomModal.Wrapper>
            )}

            <img
              height={200}
              width={200}
              className="rounded-lg"
              src={pic || Utils.placeholderImage()}
              alt={name}
              data-no-retina=""
              // onClick={handleClick}
            />

            <div className="w-full">
              <span className="font-medium text-sm text-darkgray ">{name}</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col py-[20px] md:items-center relative">
          {(v || yt) && (
            <CustomModal.Wrapper
              className="absolute top-0 left-0 w-full h-full -mt-[10px] flex justify-center items-center"
              modalBtn={
                <IconButton>
                  <i className="icon-control-play text-white text-[30px]" />
                </IconButton>
              }
            >
              <div className="w-[1020px] max-w-full relative rounded mx-auto">
                <div className="fit-video">
                  {v && (
                    <iframe
                      width="100%"
                      height="100%"
                      className="shadow-[0_0_8px_rgba(0,0,0,0.06)]"
                      controls
                      src={v}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  )}
                  {yt && (
                    <YouTube
                      videoId={yt}
                      opts={{
                        height: "100%",
                        width: "100%",
                        playerVars: {
                          autoplay: 1,
                        },
                      }}
                    />
                  )}
                </div>
              </div>
            </CustomModal.Wrapper>
          )}
          <img
            height={200}
            width={200}
            className="rounded-lg"
            src={pic || Utils.placeholderImage()}
            alt={name}
            data-no-retina=""
            // onClick={handleClick}
          />

          <div className="w-full">
            <span className="font-medium text-sm text-darkgray ">{name}</span>
          </div>
        </div>
      )}
    </Col>
  );
});

const ItemFeature = ({ item }) => {
  const dispatch = useDispatch();
  const feat = useSelector((s) => selectFeatureById(s, item));
  if (_.isEmpty(feat)) return null;

  const { name_lang, picture, product_properties_features_id } = feat;

  const pic = picture
    ? Utils.formatURL(
        `data_table/product_properties_features/picture/${product_properties_features_id}/${picture}?s=xs`
      )
    : null;

  const handleClick = () =>
    dispatch(
      setSliderOptions({
        open: true,
        items: [
          {
            picture_src: pic,
          },
        ],
      })
    );

  return (
    <div className="w-full flex flex-row items-center space-x-3">
      <Image
        ImgProps={{
          src: pic,
        }}
        BoxProps={{
          className: "!w-5 !h-5",
          onClick: handleClick,
        }}
      />
      {/* <img className="w-5 h-5 object-contain" src={pic} /> */}

      <span className="text-xs !text-[11px] text-gray-500">{n(name_lang)}</span>
    </div>
  );
};

export default memo(TabScrollable);
